import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class AircraftModelsAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      model: '',
      size: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.adicionar = this.adicionar.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  adicionar(event) {
    event.preventDefault();
    var datasave = {
      model: this.state.model,
      size: this.state.size,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/frota/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar frota</h3>
      <Link to="/frotas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.adicionar}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Modelo*:</label>
              <input type="text" name="model" className="form-control" placeholder="Modelo da aeronave" value={this.state.model} onChange={this.handleChange.bind(this, 'model')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Porte*:</label>
              <Select
                className="form-field-name"
                name="size"
                value={this.state.size}
                searchable={true}
                placeholder={'Selecionar o porte'}
                onChange={this.handleSelectChange.bind(this, 'size')}
                options={[
                  {value: "PP", label: "Pequeno-Porte"},
                  {value: "MP", label: "Médio-Porte"},
                  {value: "SMP", label: "Super Médio-Porte"},
                  {value: "GP", label: "Grande-Porte"},
                ]}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button input={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar frota</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftModelsAdd;



// WEBPACK FOOTER //
// ./src/Components/AircraftModels/AircraftModelsAdd.js